import React from 'react';
import type { FlatMostPopularSectionProps } from '../../types';
import Carousel from './Carousel';
import RichText from '@/components/ui/RichText/RichText';

export default function MostPopularSection({
  data,
  onEnquire,
  onBook,
}: FlatMostPopularSectionProps): React.ReactElement {
  const items = data?.packages ?? [];
  const heading = data?.heading;
  const labels = data?.labels;

  return (
    <section
      id="Packages"
      className="content-wrapper font-regular mx-auto scroll-m-36 px-4 pt-8 pb-4"
    >
      {heading?.content && (
        <div
          className="flex flex-col items-center justify-center text-center"
          id="ourMostPopularPackages"
        >
          <RichText styles={heading.styles}>{heading.content}</RichText>
        </div>
      )}

      <Carousel
        items={items}
        labels={labels}
        onEnquire={onEnquire}
        onBook={onBook}
      />
    </section>
  );
}
